import React, { createContext, useState, useContext, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { useClinicalTrial } from "./Hooks";

const ClinicalTrialContext = createContext();
export const useClinicalTrialContext = () => useContext(ClinicalTrialContext);

export const ClinicalTrialProvider = ({ children }) => {
  const [startup, setStartupState] = useState(null);
  const startupRef = useRef(null);
  const [isfFilesData, setIsfFilesData] = useState(null);
  const [patientsData, setPatientsData] = useState(null);
  const { id: clinicalTrialId } = useParams();

  const setStartup = useCallback((updater) => {
    const next = typeof updater === "function" ? updater(startupRef.current) : updater;
    startupRef.current = next;
    setStartupState(next);
  }, []);

  const [isLoading, brief] = useClinicalTrial(clinicalTrialId);

  useEffect(() => {
    if (!isLoading && brief && brief.startup) {
      const loadedStartup = {
        ...brief.startup,
        attachments: brief.attachments,
        statusHistory: brief.statusHistory
      };

      // Cargo los roles de cada profesional
      [
        ["subInvestigatorId", "subInvestigatorRoleId"],
        ["studyCoordinatorId", "studyCoordinatorRoleId"],
        ["dataManagerId", "dataManagerRoleId"],
        ["pharmacistId", "pharmacistRoleId"],
        ["nurcingId", "nurcingRoleId"],
        ["administratorId", "administratorRoleId"],
        ["monitorId", "monitorRoleId"],
      ].forEach((x) => {
        // Manejo la lista como una tupla donde x[0] es el campo donde tengo el ID del practitioner
        // en el protocolo y x[1] es el campo del rol en startup, similar al EditViewModel
        if (brief.startup.protocol[x[0]]) {
          const practitionerId = brief.startup.protocol[x[0]];
          var protocolPractitioner =
            brief.startup.protocol.protocolPractitioners?.find(
              (p) => p.practitionerUserId === practitionerId
            );
          if (protocolPractitioner) {
            loadedStartup[x[1]] = protocolPractitioner.studyRoleId;
          }
        }
      });

      startupRef.current = loadedStartup;
      setStartupState(loadedStartup);
    }
  }, [isLoading, brief]);

  const value = {
    startup,
    startupRef,
    setStartup,
    isfFilesData,
    setIsfFilesData,
    patientsData,
    setPatientsData,
  };

  return (
    <ClinicalTrialContext.Provider value={value}>
      {!isLoading && startup && children}
    </ClinicalTrialContext.Provider>
  );
};
